import { render, staticRenderFns } from "./ConfigurationZone.vue?vue&type=template&id=0c1e855a&scoped=true&"
import script from "./ConfigurationZone.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationZone.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationZone.vue?vue&type=style&index=0&id=0c1e855a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1e855a",
  null
  
)

export default component.exports